exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "label{width:130px;text-align:right;padding-right:10px}.quill{width:100%;height:100%;box-sizing:border-box;flex-grow:1}.form-error-field{border:red 1px solid;width:100%;height:100%}.form-field-wrapper{width:100%;height:100%}\n", ""]);

